import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { TitleComponent } from './components/title/title.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MessageService, PrimeIcons } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PasswordModule } from 'primeng/password';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { MenubarModule } from 'primeng/menubar';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { FileUploadModule } from 'primeng/fileupload';
import { TabMenuModule } from 'primeng/tabmenu';
import { SidebarModule } from 'primeng/sidebar';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DividerModule } from 'primeng/divider';
import { ChartModule } from 'primeng/chart';
import { TextViewControlComponent } from './components/text-view-control/text-view-control.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { ResponseTableComponent } from './components/response-table/response-table.component';
import { ResponseChartComponent } from './components/response-chart/response-chart.component';
import { ResponseDownloadComponent } from './components/response-download/response-download.component';
import { InputOtpModule } from 'primeng/inputotp';
import { PanelModule } from 'primeng/panel';
import { IndianNumberPipe } from './pipes/indian-number.pipe';
import { InputMaskModule } from 'primeng/inputmask';

const modules = [
  MenuModule,
  ChartModule,
  AutoCompleteModule,
  MenubarModule,
  ButtonModule,
  TableModule,
  ToastModule,
  InputTextModule,
  DropdownModule,
  PasswordModule,
  CardModule,
  CalendarModule,
  FieldsetModule,
  SelectButtonModule,
  InputGroupModule,
  InputGroupAddonModule,
  InputNumberModule,
  AvatarModule,
  BadgeModule,
  DialogModule,
  ProgressBarModule,
  FileUploadModule,
  TabMenuModule,
  SidebarModule,
  RippleModule,
  StyleClassModule,
  TieredMenuModule,
  PanelMenuModule,
  DividerModule,
  MultiSelectModule,
  AccordionModule,
  CheckboxModule,
  ConfirmDialogModule,
  InputTextareaModule,
  ConfirmPopupModule,
  ScrollPanelModule,
  InputOtpModule,
  PanelModule,
  InputMaskModule 
]
@NgModule({
  declarations: [
    LoaderComponent,
    TitleComponent,
    TextViewControlComponent,
    CurrencyFormatPipe,
    ResponseTableComponent,
    ResponseChartComponent,
    ResponseDownloadComponent,
    IndianNumberPipe
  ],
  imports: [
    CommonModule,
    ...modules,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  exports: [
    ...modules,
    FormsModule,
    ReactiveFormsModule,
    TitleComponent,
    LoaderComponent,
    TextViewControlComponent,
    CurrencyFormatPipe,
    ResponseTableComponent,
    ResponseChartComponent,
    ResponseDownloadComponent,
    IndianNumberPipe,
    CardModule
  ],
  providers: [MessageService, DatePipe, CurrencyFormatPipe, ConfirmationService,
    { provide: LOCALE_ID, useValue: 'en-IN' }

  ],
})
export class SharedModule { }
